import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { InfoPage } from 'components/common/Layout/InfoPage/InfoPage';
import ModalComponent from 'components/utils/ModalComponent';

import { toggleModalWithTimer } from 'actions/appAction';

const ModalWithTimer = (props) => {
    const timerId = useRef(null);

    useEffect(() => {
        if (document.activeElement && document.activeElement.tagName === 'INPUT') {
            const focusedInput = document.activeElement;
            setTimeout(() => {
                focusedInput.blur();
            }, 1000);
        }
        if (!timerId.current) {
            const closeModal = () => {
                if (props.onClick) {
                    props.onClick();
                } else if (props.onClose) {
                    props.onClose();
                } else {
                    props.toggleModalWithTimer(false, '', false);
                }
            };
            timerId.current = setTimeout(closeModal, 2000);
        }
        return () => clearTimeout(timerId.current);
    }, []);
    return (
        <ModalComponent canCloseModal={false} isVerticalCentered>
            <InfoPage animatedIconSuccess mainText={props.message || props.text} insideModalComponent />
        </ModalComponent>
    );
};
ModalWithTimer.propTypes = {
    message: PropTypes.string, // props for action toggleModalWithTimer
    text: PropTypes.string, // props for ModalWithTimer component
    onClick: PropTypes.func, // props for ModalWithTimer component
    onClose: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]), // props for action  toggleModalWithTimer
};
const mapStateToProps = (state) => {
    return {
        message: state.app.messageForModalWithTimer,
        onClose: state.app.onCloseForModalWithTimer,
    };
};
export default connect(mapStateToProps, { toggleModalWithTimer })(ModalWithTimer);
